<template>
	<div class="block social blue disabled">
		<router-link :to="{path: `/client/${getClientSlug}/analytics`}">
			<h3>Analytics</h3>
			<div class="row">
				<p>Sessions</p>
				<div class="stats">
					<p class="number">{{ sessionsVal }}</p>
					<div class="conversion-rate up">
						<div class="grid-container">
							<div class="col">
								<p>{{ conversionRate }}</p>
							</div>
							<div class="col">
								<span class="arrow">
									<i class="fa-solid fa-arrow-up-long"></i>
								</span>
							</div>
						</div>
					</div>
					<!-- end conversion-rate -->
				</div>
				<!-- end stats -->
				<p class="dark">than last month</p>
			</div>
			<!-- end row -->
			<div class="row graph-row">
				<div class="graph">
					<span></span>
					<img class="graph" v-bind:src="graph" />
				</div>
				<!-- end graph -->
			</div>
			<!-- end row -->
			<span class="arrow-link">Analytics information</span>
		</router-link>
	</div>
</template>

<script>
import {mapGetters} from "vuex"

let sessions = "156,927"
let conversionPercent = ""

export default {
	data() {
		return {
			graph: require("../../assets/img/blue-graph.png"),
			sessionsVal: sessions === "" ? "--" : sessions,
			conversionRate: conversionPercent === "" ? "--" : conversionPercent,
		}
	},
	computed: {
		...mapGetters("client", ["getClientSlug"]),
	},
}
</script>
